import {
    TablePagination,
    Button,
    TextField,
    Select,
    MenuItem,
    Box,
    Typography,
} from '@material-ui/core';
import { ApplicationsTablePaginationProps } from '€lib/types/ApplicationsTableTypes';

export default function ApplicationsDetailedTablePagination({
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    pageIndex,
    nextPage,
    previousPage,
    pageSize,
    setPageSize,
}: ApplicationsTablePaginationProps) {
    return (
        <Box py={2} display="flex" justifyContent="flex-end" alignItems="center" pr={2}>
            <Button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
                {'<<'}
            </Button>
            <Button onClick={() => previousPage()} disabled={!canPreviousPage}>
                {'<'}
            </Button>
            <Button onClick={() => nextPage()} disabled={!canNextPage}>
                {'>'}
            </Button>
            <Button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
                {'>>'}
            </Button>
            <Box mr={2}>
                <Typography>
                    Page{' '}
                    <strong>
                        {pageIndex + 1} of {pageOptions.length}
                    </strong>
                </Typography>
            </Box>
            <Select
                variant="outlined"
                value={pageSize}
                onChange={e => {
                    setPageSize(Number(e.target.value));
                }}
            >
                {[5, 10, 25].map(pageSize => (
                    <MenuItem key={pageSize} value={pageSize}>
                        Show {pageSize}
                    </MenuItem>
                ))}
            </Select>
        </Box>
    );
}
